/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var EmailOutlineIcon = function EmailOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5ZM4.74994 6.03152C4.82986 6.01094 4.91365 6 5 6H19C19.0863 6 19.1701 6.01094 19.2501 6.03152C19.1172 6.06572 18.9893 6.12793 18.8753 6.21917L12.6247 11.2197C12.2595 11.5118 11.7405 11.5118 11.3753 11.2197L5.1247 6.21917C5.01065 6.12793 4.88276 6.06571 4.74994 6.03152ZM4 7.88066V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V7.88066L13.8741 12.7814C12.7784 13.6579 11.2216 13.6579 10.1259 12.7814L4 7.88066Z"
  }));
};
export default EmailOutlineIcon;